<div *ngIf="ContractClients.length==0;then noData else data"></div>

<ng-template #noData>
    <div class="col-md-12">
        <p> {{ 'NoDataFound' | translate }}</p>
    </div>
</ng-template>

<ng-template #data>
    <div class="row">
        <div class="col-md-3">
            <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden"
                *ngIf="ContractClients.length!=0 || WarrantyClients.length!=0">
                <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
                    <input class="search-txt" placeholder="{{ 'search' | translate }}" maxlength="100" />
                    <i-tabler name="search" class="icon-20 d-flex icon m-l-6 m-t-6"></i-tabler>
                </mat-card-header>

                <mat-tab-group (selectedTabChange)="tabClick($event)">
                    <mat-tab label="{{ 'contracts' | translate}}">
                        <div class="col-md-12 navi">
                            <ul>
                                <li class="m-b-6" [ngClass]="{active:selectedContractClientName===clientName}"
                                    *ngFor="let clientName of ContractClients">
                                    <a (click)="ShowProducts('contract',clientName)">
                                        {{clientName}}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </mat-tab>

                    <mat-tab label="{{ 'warranties' | translate}}">
                        <div class="col-md-12 navi">
                            <ul>
                                <li class="m-b-6" [ngClass]="{active:selectedWarrantyClientName===clientName}"
                                    *ngFor="let clientName of WarrantyClients">
                                    <a (click)="ShowProducts('warranty',clientName)">
                                        {{clientName}}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </mat-card>
        </div>

        <div class="col-md-9" *ngIf="ContractClients.length!=0 || WarrantyClients.length!=0">
            <div *ngIf="isContracts;then contracts else Warranties"></div>
            <ng-template #contracts>
                <app-contract-product-list [ContractProductList]="ContractProductList"></app-contract-product-list>
            </ng-template>

            <ng-template #Warranties>
                <app-warranty-product-list [WarrantyProductList]="WarrantyProductList"></app-warranty-product-list>
            </ng-template>
        </div>
    </div>
</ng-template>